import { Box, styled } from "@mui/system";

export const FormWrapper = styled(Box)({
  padding: '20px 0',
});
export const FormTitle = styled(Box)({
  fontWeight: 'bold',
  fontSize: '18px',
  marginBottom: '20px',
  marginLeft: '25px',
});

export const FormContainer = styled(Box)({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'center',
  marginBottom: '50px',
});

export const FieldContainer = styled(Box)({
  width: '325px',
  margin: '5px 25px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  "& .MuiFormLabel-root": {
    marginBottom: '9px',
  },
  "& .MuiInputBase-root": {
    minWidth: '100%',
    minHeight: '30px',
    border: '1px solid #b2b9dc',
    borderRadius: '4px',
    "& input": {
      paddingLeft: '10px',
      paddingRight: '10px',
      paddingBottom: '0px',
      paddingTop: '0px',
    }
  },
});

export const MultiFieldContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
});
  

export const ButtonsContainer = styled(Box)({
  margin: '0 25px',
  textAlign:'center',
  "& .MuiButtonBase-root": {
    marginRight: '18px',
    height: '26px',
    fontSize: '12px',
  },
});

export const TextAreaContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  borderBottom: '0',
  justifyContent: 'space-between',
  margin: '15px 25px',
  "& .MuiInputBase-root": {
    background: '#f2f4ff',
    minWidth: '100%',
    minHeight: '200px',
  },
  "& .MuiFormLabel-root": {
    minHeight: '50px',
    textWrap: 'wrap',
  },
  "& textarea": {
    minWidth: '100%',
    minHeight: '30px',
    border: '1px solid #b2b9dc',
    borderRadius: '4px',
    resize: 'none',
    padding: '10px',
  }
});

export const SectionContainer = styled(Box)({
    border: '1px solid #5c088c',
    borderRadius: '5px',
    padding: '20px',
    margin: '10px',
});

export const SectionTitle = styled(Box)({
    fontSize: '15px',
    marginBottom: '15px',
    color: '#5c088c',
    textTransform: 'uppercase',
    fontWeight: 'bold'
})
